import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SupportForm } from './index';
import { useHeader } from '../header';
import { TheezyIcon } from '../icons';
import { useNavigate } from 'react-router-dom';


export const AuthenticatedSupportView = () => {
    const { setHeaderTitle, setHeaderSubTitle } = useHeader();
    const navigate = useNavigate();

    useEffect(() => {
        setHeaderTitle('Support');
        setHeaderSubTitle("Need help? Send us a message and we'll follow up by email.");
    });

    const triggerRedirect = () => {
        navigate(-1);
    }

    return (
        <div className="survey-page">
            <div className="survey-view">
                <SupportForm onSuccess={triggerRedirect}/>
            </div>
        </div>
    );
};

export const PublicSupportView = () => {
    const navigate = useNavigate();

    const onSuccess = () => {
        navigate('/');
    }

    return (
        <div className="support-page-public">
            <div className="orb orb-1"/>
            <div className="orb orb-2"/>
            <div className="orb orb-3"/>
            <div className="grid-overlay"/>

            <div className="support-page-public-logo">
                <TheezyIcon/>
            </div>

            <div className="support-page-public-card">
                <div className="survey-view">
                    <SupportForm onSuccess={onSuccess}/>
                </div>
            </div>

            <Link to="/" className="support-page-public-back">← Back to sign in</Link>
        </div>
    )
};